import moment from 'moment';
global.moment = moment;

global.cnsl = (success, msg) => {
    if (success) return console.log('\x1b[38;5;37m%s\x1b[0m', `* ✅ ${msg} *`);
    return console.log('\x1b[38;5;208m%s\x1b[0m', `* ❌ ${msg} *`);
}
cnsl(true, `[mio-next/mongo] Globals Loaded`);


global.normalise = {
    null(value) {
        return value?.toString().trim() || null;
    },
    upper(value) {
        return this.null(value)?.toUpperCase() || null;
    },
    lower(value) {
        return this.null(value)?.toLowerCase() || null;
    },
    num(value) {
        value = this.null(value);
        if (!value) return null;
        const num = Number(value);
        return isNaN(num) ? null : num;
    },
    bool(value) {
        value = this.null(value);
        return value === true || value === 'true' || value === 1 || value === '1';
    },
    date(value) {
        const date = moment(value, 'YYYY-MM-DD');
        if (!date.isValid()) return null;
        return date.toDate();
    },
    search(value) {
        value = this.lower(value);
        return value?.normalize("NFD").replace(/[\u0300-\u036f]/g, "") || null; // Remove diacritics
    }
}

global.delay = async (ms) =>
    new Promise((resolve) =>
        setTimeout(() => {
            resolve()
        }, ms)
    )

